var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/home' }}},[_vm._v("首页")]),_c('el-breadcrumb-item',[_vm._v("数据统计")]),_c('el-breadcrumb-item',[_vm._v("数据报表")])],1),_c('el-card',[_c('div',{staticStyle:{"width":"750px","height":"400px"},attrs:{"id":"main"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }